import { tutorialJourneyProfilesClient } from "../api/ApiClients";
import {
  ApplyTutorialJourneyProfileCommand,
  CreateTutorialJourneyProfileCommand,
  IApplyTutorialJourneyProfileCommand,
  ICreateTutorialJourneyProfileCommand,
  ITutorialJourneyProfileDto,
  ITutorialJourneysViewModel,
} from "@growth-machine-llc/stridist-api-client";
import ServiceBase from "./ServiceBase";

class TutorialJourneyProfilesService extends ServiceBase {
  async getTutorialJourneysProfiles(): Promise<ITutorialJourneysViewModel> {
    return tutorialJourneyProfilesClient.getTutorialJourneyProfiles();
  }

  async createTutorialJourneyProfile(
    data: ICreateTutorialJourneyProfileCommand,
  ) {
    const command = CreateTutorialJourneyProfileCommand.fromJS(data);
    return tutorialJourneyProfilesClient.createTutorialJourneyProfile(command);
  }

  async applyTutorialJourneyProfile(data: IApplyTutorialJourneyProfileCommand) {
    const command = ApplyTutorialJourneyProfileCommand.fromJS(data);
    return tutorialJourneyProfilesClient.applyTutorialJourneyProfile(command);
  }

  async deleteTutorialJourneyProfile(id: number) {
    return tutorialJourneyProfilesClient.deleteTutorialJourneyProfile(id);
  }
}

export default new TutorialJourneyProfilesService();
